import { useEffect } from 'react';

let lockCount = 0;

const useLockBodyScroll = (show: boolean) => {
    useEffect(() => {
        if (!show) {
            return;
        }

        lockCount++;
        document.body.style.overflow = 'hidden';

        return () => {
            lockCount--;
            if (lockCount === 0) {
                document.body.style.overflow = '';
            }
        };
    }, [show]);
}

export default useLockBodyScroll;
